import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import {VetReservation} from "../../../models/vet-reservation.model";
import {NamedRoom, VideoChatService} from "../../../providers/videochat.service";
import {tap} from "rxjs/operators";
import {AppStateService} from "../../../providers/app-state.service";

@Component({
  selector: 'app-rooms',
  styleUrls: ['./rooms.component.scss'],
  templateUrl: './rooms.component.html',
})
export class RoomsComponent implements OnInit {
  @Output() roomChanged = new EventEmitter<string>();
  @Input() activeRoomName: string;
  @Input() vetReservation: VetReservation;
  isBusy: boolean;
  isBusySub: Subscription;

  roomName: string;
  rooms: NamedRoom[];

  private subscription: Subscription;

  constructor(
    private readonly videoChatService: VideoChatService, private appStateService: AppStateService) { }

  async ngOnInit() {
    await this.updateRooms();
    this.subscription =
      this.videoChatService
        .roomsUpdated
        .pipe(tap(_ => this.updateRooms()))
        .subscribe();
    this.isBusySub=this.appStateService.isBusySubject.subscribe(e=>this.isBusy=e);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if(this.isBusySub){
      this.isBusySub.unsubscribe();
    }
  }

  onTryAddRoom() {
    if (this.roomName) {
      this.onAddRoom(this.roomName);
    }
  }

  onAddRoom(roomName: string) {
    this.roomName = null;
    this.roomChanged.emit(roomName);
  }

  onJoinRoom(roomName: string) {
    this.roomChanged.emit(roomName);
  }

  async updateRooms() {
    this.rooms = [] /*(await this.videoChatService.getAllRooms())*/ as NamedRoom[];
  }

}
